import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "@/assets/css/common.less"; // 引入全局样式
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store/store";
import { Provider } from "react-redux";
import {
  legacyLogicalPropertiesTransformer,
  StyleProvider,
} from "@ant-design/cssinjs";
import '@fontsource/pt-serif';

// 全局错误处理：捕获并静默处理 MetaMask 相关错误
window.addEventListener('error', (event) => {
  // 检查是否是 MetaMask 相关的错误
  if (
    event.message && 
    (
      event.message.includes('Failed to connect to MetaMask') ||
      event.message.includes('MetaMask') ||
      (event.filename && event.filename.includes('nkbihfbeogaeaoehlefnkodbefgpgknn'))
    )
  ) {
    // 静默处理 MetaMask 错误，不显示在控制台
    event.preventDefault();
    return true;
  }
  return false;
});

// 捕获未处理的 Promise 拒绝（MetaMask 可能抛出）
window.addEventListener('unhandledrejection', (event) => {
  if (
    event.reason &&
    (
      (typeof event.reason === 'string' && event.reason.includes('MetaMask')) ||
      (event.reason.message && event.reason.message.includes('MetaMask')) ||
      (event.reason.message && event.reason.message.includes('Failed to connect'))
    )
  ) {
    // 静默处理 MetaMask 相关的 Promise 拒绝
    event.preventDefault();
    return true;
  }
  return false;
});

// 安全地处理 window.ethereum（如果存在）
if (typeof window !== 'undefined' && window.ethereum) {
  try {
    // 如果不需要使用 MetaMask，可以移除事件监听器以避免错误
    // 或者添加错误处理包装器
    const originalRequest = window.ethereum.request;
    if (originalRequest) {
      window.ethereum.request = function(...args) {
        return originalRequest.apply(this, args).catch((error) => {
          // 静默处理 MetaMask 请求错误
          if (error.message && error.message.includes('Failed to connect')) {
            console.warn('MetaMask 连接失败（已静默处理）');
            return Promise.reject(error);
          }
          throw error;
        });
      };
    }
  } catch (error) {
    // 忽略初始化错误
  }
}

ReactDOM.render(
  <StyleProvider
    hashPriority="high"
    transformers={[legacyLogicalPropertiesTransformer]}
  >
    <Provider store={store}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </Provider>
  </StyleProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
